import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const checkUserApi = createAsyncThunk(
  "user/checkUser",
  async (identifierData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/users/check-user", identifierData);
      return response.data;
    } catch (error) {
      console.error("CheckUser API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to check user",
        );
      }
      return rejectWithValue("Failed to check user");
    }
  },
);
